import React from "react";

const Dashboard = () => {
  return <div>Dashboard page</div>;
};

export default Dashboard;
